import { CircularProgress } from "components/DesignSystem/CircularProgress/CircularProgress";
import { colors } from "constants/colors";
import { EntitySetupChecklist } from "v2/components/FilingsDashboard/EntitySetupChecklist";
import { DashboardEntity } from "v2/pages/FilingsDashboard/FilingsDashboard";

type CompleteWithAIHeaderProps = {
  onboardingProgress: number;
  entities: DashboardEntity[];
  progressById: Record<string, number>;
};

export const CompleteWithAIHeader = ({
  onboardingProgress,
  entities,
  progressById,
}: CompleteWithAIHeaderProps) => {
  const isMultiEntity = entities.length > 1;

  return (
    <div className="t-flex t-items-center t-gap-3">
      <CircularProgress
        value={onboardingProgress}
        size={36}
        strokeWidth={3}
        progressColor={colors.dark_green.DEFAULT}
      />

      <div className="t-flex t-flex-col t-items-start t-justify-center t-gap-1">
        <span className="t-text-subtext-lg t-text-text-100">
          Onboarding set up
        </span>

        {isMultiEntity ? (
          <EntitySetupChecklist
            entities={entities}
            progressById={progressById}
            orientation="horizontal"
          />
        ) : (
          <span className="t-text-caption t-text-text-30">
            {entities[0].name}
          </span>
        )}
      </div>
    </div>
  );
};
